export interface ITryOnSunColor {
    title: string;
    colorBg: string;
    color_rgb?: number[][];
    text: string;
    isColorAni?: boolean;
    color_img?: string;
}
export const tryonSunColorList: ITryOnSunColor[] = [
    {
        title: "GREY",
        colorBg: "#0f1321",
        color_rgb: [[15, 19, 33, 0.85]],
        text: "TintPolarizedTip",
    },
    {
        title: "BROWN",
        colorBg: "#4a3D38",
        color_rgb: [[74, 61, 56, 0.9]],
        text: "TintPolarizedTip",
    },
    {
        title: "GREEN",
        colorBg: "#1d3738",
        color_rgb: [[29, 55, 56, 0.8]],
        text: "TintPolarizedTip",
    },
    {
        title: "BLUE",
        colorBg: "#063c96",
        color_rgb: [[6, 60, 150, 0.9]],
        text: "TintTip",
    },
    {
        title: "PURPLE",
        colorBg: "#3c0e5f",
        color_rgb: [[60, 14, 95, 0.9]],
        text: "TintTip",
    },
    {
        title: "GRADIENT_BROWN",
        colorBg: "linear-gradient(0deg, #BAB1A5 0%, #49441C 100%)",
        color_rgb: [
            [32, 16, 8, 0.9],
            [132, 119, 74, 0.5],
        ],
        text: "TintTip",
    },
    {
        title: "GRADIENT_GREY",
        colorBg: "linear-gradient(180deg, #445560 0%, #B6BCBD 100%)",
        color_rgb: [
            [18, 14, 36, 0.9],
            [106, 96, 68, 0.5],
        ],
        text: "TintTip",
    },
    {
        title: "GRADIENT_GREEN",
        colorBg: "linear-gradient(0deg, #CED0CE 0%, #397352 100%)",
        color_rgb: [
            [22, 29, 25, 0.9],
            [139, 152, 149, 0.3],
        ],
        text: "TintTip",
    },
    {
        title: "GRADIENT_BURGUNDY",
        colorBg: "linear-gradient(0deg, #E3C1C2 0%, #D8799F 100%)",
        color_rgb: [
            [73, 27, 37, 0.8],
            [207, 194, 134, 0.5],
        ],
        text: "TintTip",
    },
    {
        title: "GRADIENT_PURPLE",
        colorBg: "linear-gradient(0deg, #CBC3CC 0%, #B06DBF 63%, #7A4EA7 100%)",
        color_rgb: [
            [21, 15, 27, 0.9],
            [72, 47, 77, 0.8],
            [141, 123, 109, 0.6],
        ],
        text: "TintTip",
    },
    {
        title: "PhotochromicBrown",
        colorBg: "#48140f",
        isColorAni: true,
        color_rgb: [[72, 20, 15, 0.8]],
        text: `PhotochromicTip`,
    },
    {
        title: "PhotochromicGrey",
        colorBg: "#2c2c2c",
        isColorAni: true,
        color_rgb: [[44, 44, 44, 0.8]],
        text: `PhotochromicTip`,
    },
    {
        title: "MIRROR_BLUE",
        colorBg:
            'url("https://df5apg8r0m634.cloudfront.net/images/2021/0302/d5e1e80a59ebf383733b7e41a192bb93.png") no-repeat center center',
        color_img:
            "https://df5apg8r0m634.cloudfront.net/images/2022/1220/8f4015031e901e719f87e68b1f7d1b1b.png",
        text: `MirrorTip`,
    },
    {
        title: "MIRROR_SILVER",
        colorBg:
            'url("https://df5apg8r0m634.cloudfront.net/images/2021/0302/1e44c2462502f3a087478e81c41fdeee.png") no-repeat center center',
        color_img:
            "https://df5apg8r0m634.cloudfront.net/images/2022/1222/bc3d129ab4722b19f89784eaaf2e1f21.png",
        text: `MirrorTip`,
    },
];

export const tryonColorList: ITryOnSunColor[] = [
    {
        title: "Clear",
        colorBg: "#f4f2f0",
        color_rgb: [[0, 0, 0, 0]],
        text: "ClearTip",
    },
    {
        title: "GREY",
        colorBg: "#0f1321",
        color_rgb: [[15, 19, 33, 0.85]],
        text: "TintPolarizedTip",
    },
    {
        title: "GREY_LIGHT",
        colorBg: "#5d5d5d",
        color_rgb: [[93, 93, 93, 0.2]],
        text: "TintTip",
    },
    {
        title: "BROWN",
        colorBg: "#4a3D38",
        color_rgb: [[74, 61, 56, 0.9]],
        text: "TintPolarizedTip",
    },
    {
        title: "BROWN_LIGHT",
        colorBg: "#aa7444",
        color_rgb: [[170, 116, 68, 0.2]],
        text: "TintTip",
    },
    {
        title: "GREEN",
        colorBg: "#1d3738",
        color_rgb: [[29, 55, 56, 0.8]],
        text: "TintPolarizedTip",
    },
    {
        title: "GREEN_LIGHT",
        colorBg: "#6a7f70",
        color_rgb: [[106, 127, 112, 0.2]],
        text: "TintTip",
    },
    {
        title: "BLUE",
        colorBg: "#063c96",
        color_rgb: [[6, 60, 150, 0.9]],
        text: "TintTip",
    },
    {
        title: "BLUE_LIGHT",
        colorBg: "#219df3",
        color_rgb: [[33, 157, 243, 0.2]],
        text: "TintTip",
    },
    {
        title: "PURPLE",
        colorBg: "#3c0e5f",
        color_rgb: [[60, 14, 95, 0.9]],
        text: "TintTip",
    },
    {
        title: "PURPLE_LIGHT",
        colorBg: "#bda3c9",
        color_rgb: [[189, 163, 201, 0.2]],
        text: "TintTip",
    },
    {
        title: "PINK_LIGHT",
        colorBg: "#c28582",
        color_rgb: [[194, 133, 130, 0.2]],
        text: "TintTip",
    },
    {
        title: "YELLOW_LIGHT",
        colorBg: "#bbc28a",
        color_rgb: [[187, 194, 138, 0.2]],
        text: "TintTip",
    },
    {
        title: "GRADIENT_BROWN",
        colorBg: "linear-gradient(0deg, #BAB1A5 0%, #49441C 100%)",
        color_rgb: [
            [32, 16, 8, 0.9],
            [132, 119, 74, 0.5],
        ],
        text: "TintTip",
    },
    {
        title: "GRADIENT_GREY",
        colorBg: "linear-gradient(180deg, #445560 0%, #B6BCBD 100%)",
        color_rgb: [
            [18, 14, 36, 0.9],
            [106, 96, 68, 0.5],
        ],
        text: "TintTip",
    },
    {
        title: "GRADIENT_GREEN",
        colorBg: "linear-gradient(0deg, #CED0CE 0%, #397352 100%)",
        color_rgb: [
            [22, 29, 25, 0.9],
            [139, 152, 149, 0.3],
        ],
        text: "TintTip",
    },
    {
        title: "GRADIENT_BURGUNDY",
        colorBg: "linear-gradient(0deg, #E3C1C2 0%, #D8799F 100%)",
        color_rgb: [
            [73, 27, 37, 0.8],
            [207, 194, 134, 0.5],
        ],
        text: "TintTip",
    },
    {
        title: "GRADIENT_PURPLE",
        colorBg: "linear-gradient(0deg, #CBC3CC 0%, #B06DBF 63%, #7A4EA7 100%)",
        color_rgb: [
            [21, 15, 27, 0.9],
            [72, 47, 77, 0.8],
            [141, 123, 109, 0.6],
        ],
        text: "TintTip",
    },
    {
        title: "PhotochromicBrown",
        colorBg: "#48140f",
        isColorAni: true,
        color_rgb: [[72, 20, 15, 0.8]],
        text: `PhotochromicTip`,
    },
    {
        title: "PhotochromicGrey",
        colorBg: "#2c2c2c",
        isColorAni: true,
        color_rgb: [[44, 44, 44, 0.8]],
        text: `PhotochromicTip`,
    },
    {
        title: "PhotochromicAmber",
        isColorAni: true,
        colorBg: "#4a1600",
        color_rgb: [[74, 22, 0, 0.8]],
        // color_img:'https://df5apg8r0m634.cloudfront.net/images/2022/1212/2b6f5bff2a4e9fc81ddcd25b6499f362.png',
        text: `TransitionsTip`,
    },
    {
        title: "PhotochromicGraphiteGreen",
        colorBg: "#2b310d",
        isColorAni: true,
        color_rgb: [[43, 49, 13, 0.8]],
        text: `TransitionsTip`,
    },
    {
        title: "PhotochromicSapphire",
        colorBg: "#0f3b6e",
        color_rgb: [[15, 59, 110, 0.8]],
        isColorAni: true,
        text: `TransitionsTip`,
    },
    {
        title: "PhotochromicAmethyst",
        colorBg: "#3a174f",
        isColorAni: true,
        color_rgb: [[58, 23, 79, 0.8]],
        text: `TransitionsTip`,
    },
];

export const tryonRidingList = [
    {
        title: "Clear",
        colorBg: "#f4f2f0",
        color_rgb: [[0, 0, 0, 0]],
        text: "RidingNoColorTip",
    },
    {
        title: "PolarizedGrey",
        colorBg: "#0F1321",
        color_rgb: [[15, 19, 33, 0.85]],
        text: `RidingPolarizedTip`,
    },
    {
        title: "MirrorBlue",
        colorBg:
            'url("https://df5apg8r0m634.cloudfront.net/images/2024/0802/a90c2f4c38019a0b2eb0196ffdc9551c.png") no-repeat center center',
        color_img:
            "https://df5apg8r0m634.cloudfront.net/images/2024/0806/857a6b2cedf1abf22ac01424786df298.png",
        text: `RidingTintPolarizedTip`,
    },
    {
        title: "MirrorMagenta",
        colorBg:
            'url("https://df5apg8r0m634.cloudfront.net/images/2024/0802/b789235c6acc227b06e4e2659de39bde.png") no-repeat center center',
        color_img:
            "https://df5apg8r0m634.cloudfront.net/images/2024/0806/ebd4ce7f8f1e601d953961011a202394.png",
        text: `RidingTintPolarizedTip`,
    },
    {
        title: "MirrorGreen",
        colorBg:
            'url("https://df5apg8r0m634.cloudfront.net/images/2024/0802/fdd55d2b708571b5c460ad72d33cdfcd.png") no-repeat center center',
        color_img:
            "https://df5apg8r0m634.cloudfront.net/images/2024/0806/f158c6d9ef446f24201c29e50672279c.png",
        text: `RidingTintPolarizedTip`,
    },
    {
        title: "Photochromic_Grey",
        colorBg: "#0F1321",
        isColorAni: true,
        color_rgb: [[15, 19, 33, 0.85]],
        text: `RidingPhotochromicTip`,
    },
    {
        title: "Photochromic_MirrorBlue",
        isColorAni: true,
        opacity: 0.3,
        colorBg:
            'url("https://df5apg8r0m634.cloudfront.net/images/2024/0802/6174e53d35f81162460b94fa2bc803a3.png") no-repeat center center',
        color_img:
            "https://df5apg8r0m634.cloudfront.net/images/2024/0805/4840c89c8fab39abd5f4f0fe053ef42e.png",
        text: `RidingPhotochromicTip`,
    },
    {
        title: "Photochromic_MirrorMagenta",
        isColorAni: true,
        opacity: 0.3,
        colorBg:
            'url("https://df5apg8r0m634.cloudfront.net/images/2024/0802/b789235c6acc227b06e4e2659de39bde.png") no-repeat center center',
        color_img:
            "https://df5apg8r0m634.cloudfront.net/images/2024/0805/aac4e41a3648181383c10f114af31aa0.png",
        text: `RidingPhotochromicTip`,
    },
    {
        title: "Photochromic_MirrorGreen",
        isColorAni: true,
        opacity: 0.3,
        colorBg:
            'url("https://df5apg8r0m634.cloudfront.net/images/2024/0802/fdd55d2b708571b5c460ad72d33cdfcd.png") no-repeat center center',
        color_img:
            "https://df5apg8r0m634.cloudfront.net/images/2024/0805/87e16d0f058b582d9180826355f3a3f1.png",
        text: `RidingPhotochromicTip`,
    },
];
